/**
 * Middle School Vocabulary (Grades 7-9)
 * 初中英语词汇
 */

import { VocabularyWord } from './vocabulary';

export const middleSchoolVocabulary: VocabularyWord[] = [
  // ==================== 七年级词汇 ====================

  // 学科与教育 - Grade 7
  {
    id: 'subject',
    word: 'subject',
    phonetic: '/ˈsʌbdʒɪkt/',
    phoneticUS: '/ˈsʌbdʒɪkt/',
    phoneticUK: '/ˈsʌbdʒɪkt/',
    meaning: '科目；主题',
    example: 'English is my favorite subject.',
    exampleTranslation: '英语是我最喜欢的科目。',
    category: 'science',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    image: '📚'
  },
  {
    id: 'geography',
    word: 'geography',
    phonetic: '/dʒiˈɑɡrəfi/',
    phoneticUS: '/dʒiˈɑɡrəfi/',
    phoneticUK: '/dʒiˈɒɡrəfi/',
    meaning: '地理',
    example: 'I study geography at school.',
    exampleTranslation: '我在学校学地理。',
    category: 'science',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    image: '🌍'
  },
  {
    id: 'history',
    word: 'history',
    phonetic: '/ˈhɪstəri/',
    phoneticUS: '/ˈhɪstəri/',
    phoneticUK: '/ˈhɪstəri/',
    meaning: '历史',
    example: 'I like learning about history.',
    exampleTranslation: '我喜欢学习历史。',
    category: 'science',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    image: '📜'
  },
  {
    id: 'physics',
    word: 'physics',
    phonetic: '/ˈfɪzɪks/',
    phoneticUS: '/ˈfɪzɪks/',
    phoneticUK: '/ˈfɪzɪks/',
    meaning: '物理',
    example: 'Physics is difficult but interesting.',
    exampleTranslation: '物理很难但很有趣。',
    category: 'science',
    difficulty: 'hard',
    grade: '8',
    level: 'middle',
    image: '⚛️'
  },
  {
    id: 'chemistry',
    word: 'chemistry',
    phonetic: '/ˈkemɪstri/',
    phoneticUS: '/ˈkemɪstri/',
    phoneticUK: '/ˈkemɪstri/',
    meaning: '化学',
    example: 'We do experiments in chemistry class.',
    exampleTranslation: '我们在化学课上做实验。',
    category: 'science',
    difficulty: 'hard',
    grade: '9',
    level: 'middle',
    image: '🧪'
  },
  {
    id: 'biology',
    word: 'biology',
    phonetic: '/baɪˈɑlədʒi/',
    phoneticUS: '/baɪˈɑlədʒi/',
    phoneticUK: '/baɪˈɒlədʒi/',
    meaning: '生物',
    example: 'Biology is the study of life.',
    exampleTranslation: '生物学是研究生命的科学。',
    category: 'science',
    difficulty: 'hard',
    grade: '8',
    level: 'middle',
    image: '🧬'
  },

  // 日常活动 - Grade 7
  {
    id: 'activity',
    word: 'activity',
    phonetic: '/ækˈtɪvəti/',
    phoneticUS: '/ækˈtɪvəti/',
    phoneticUK: '/ækˈtɪvɪti/',
    meaning: '活动',
    example: 'What activities do you like?',
    exampleTranslation: '你喜欢什么活动？',
    category: 'hobbies',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    image: '🎯'
  },
  {
    id: 'practice',
    word: 'practice',
    phonetic: '/ˈpræktɪs/',
    phoneticUS: '/ˈpræktɪs/',
    phoneticUK: '/ˈpræktɪs/',
    meaning: '练习；实践',
    example: 'Practice makes perfect.',
    exampleTranslation: '熟能生巧。',
    category: 'hobbies',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    image: '💪'
  },
  {
    id: 'exercise',
    word: 'exercise',
    phonetic: '/ˈeksərsaɪz/',
    phoneticUS: '/ˈeksərsaɪz/',
    phoneticUK: '/ˈeksəsaɪz/',
    meaning: '运动；练习',
    example: 'Exercise is good for health.',
    exampleTranslation: '运动对健康有益。',
    category: 'sports',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    image: '🏃'
  },
  {
    id: 'hobby',
    word: 'hobby',
    phonetic: '/ˈhɑbi/',
    phoneticUS: '/ˈhɑbi/',
    phoneticUK: '/ˈhɒbi/',
    meaning: '爱好',
    example: 'Reading is my hobby.',
    exampleTranslation: '读书是我的爱好。',
    category: 'hobbies',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '🎨'
  },

  // 情感与态度 - Grade 7
  {
    id: 'afraid',
    word: 'afraid',
    phonetic: '/əˈfreɪd/',
    phoneticUS: '/əˈfreɪd/',
    phoneticUK: '/əˈfreɪd/',
    meaning: '害怕的',
    example: "Don't be afraid.",
    exampleTranslation: '不要害怕。',
    category: 'emotions',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '😨'
  },
  {
    id: 'nervous',
    word: 'nervous',
    phonetic: '/ˈnɜrvəs/',
    phoneticUS: '/ˈnɜrvəs/',
    phoneticUK: '/ˈnɜːvəs/',
    meaning: '紧张的',
    example: 'I feel nervous before the test.',
    exampleTranslation: '考试前我感到紧张。',
    category: 'emotions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '😰'
  },
  {
    id: 'excited',
    word: 'excited',
    phonetic: '/ɪkˈsaɪtɪd/',
    phoneticUS: '/ɪkˈsaɪtɪd/',
    phoneticUK: '/ɪkˈsaɪtɪd/',
    meaning: '兴奋的',
    example: 'I am excited about the trip.',
    exampleTranslation: '我对这次旅行很兴奋。',
    category: 'emotions',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '😃'
  },
  {
    id: 'bored',
    word: 'bored',
    phonetic: '/bɔrd/',
    phoneticUS: '/bɔrd/',
    phoneticUK: '/bɔːd/',
    meaning: '无聊的',
    example: 'I feel bored at home.',
    exampleTranslation: '我在家感到无聊。',
    category: 'emotions',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '😑'
  },
  {
    id: 'surprised',
    word: 'surprised',
    phonetic: '/sərˈpraɪzd/',
    phoneticUS: '/sərˈpraɪzd/',
    phoneticUK: '/səˈpraɪzd/',
    meaning: '惊讶的',
    example: 'I was surprised to see him.',
    exampleTranslation: '我很惊讶见到他。',
    category: 'emotions',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '😲'
  },

  // ==================== 八年级词汇 ====================

  // 科技与现代生活 - Grade 8
  {
    id: 'technology',
    word: 'technology',
    phonetic: '/tekˈnɑlədʒi/',
    phoneticUS: '/tekˈnɑlədʒi/',
    phoneticUK: '/tekˈnɒlədʒi/',
    meaning: '技术',
    example: 'Technology changes our lives.',
    exampleTranslation: '技术改变了我们的生活。',
    category: 'technology',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '💻'
  },
  {
    id: 'computer',
    word: 'computer',
    phonetic: '/kəmˈpjuːtər/',
    phoneticUS: '/kəmˈpjuːtər/',
    phoneticUK: '/kəmˈpjuːtə/',
    meaning: '电脑',
    example: 'I use a computer every day.',
    exampleTranslation: '我每天都用电脑。',
    category: 'technology',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '🖥️'
  },
  {
    id: 'internet',
    word: 'Internet',
    phonetic: '/ˈɪntərnet/',
    phoneticUS: '/ˈɪntərnet/',
    phoneticUK: '/ˈɪntənet/',
    meaning: '互联网',
    example: 'The Internet is very useful.',
    exampleTranslation: '互联网非常有用。',
    category: 'technology',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '🌐'
  },
  {
    id: 'website',
    word: 'website',
    phonetic: '/ˈwebsaɪt/',
    phoneticUS: '/ˈwebsaɪt/',
    phoneticUK: '/ˈwebsaɪt/',
    meaning: '网站',
    example: 'This is a useful website.',
    exampleTranslation: '这是一个有用的网站。',
    category: 'technology',
    difficulty: 'easy',
    grade: '8',
    level: 'middle',
    image: '🔗'
  },
  {
    id: 'information',
    word: 'information',
    phonetic: '/ˌɪnfərˈmeɪʃn/',
    phoneticUS: '/ˌɪnfərˈmeɪʃn/',
    phoneticUK: '/ˌɪnfəˈmeɪʃn/',
    meaning: '信息',
    example: 'I found some information online.',
    exampleTranslation: '我在网上找到了一些信息。',
    category: 'technology',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: 'ℹ️'
  },
  {
    id: 'message',
    word: 'message',
    phonetic: '/ˈmesɪdʒ/',
    phoneticUS: '/ˈmesɪdʒ/',
    phoneticUK: '/ˈmesɪdʒ/',
    meaning: '消息；信息',
    example: 'I sent a message to my friend.',
    exampleTranslation: '我给朋友发了一条消息。',
    category: 'technology',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '💬'
  },

  // 社会与环境 - Grade 8
  {
    id: 'environment',
    word: 'environment',
    phonetic: '/ɪnˈvaɪrənmənt/',
    phoneticUS: '/ɪnˈvaɪrənmənt/',
    phoneticUK: '/ɪnˈvaɪrənmənt/',
    meaning: '环境',
    example: 'We should protect the environment.',
    exampleTranslation: '我们应该保护环境。',
    category: 'nature',
    difficulty: 'hard',
    grade: '8',
    level: 'middle',
    image: '🌿'
  },
  {
    id: 'pollution',
    word: 'pollution',
    phonetic: '/pəˈluːʃn/',
    phoneticUS: '/pəˈluːʃn/',
    phoneticUK: '/pəˈluːʃn/',
    meaning: '污染',
    example: 'Air pollution is a big problem.',
    exampleTranslation: '空气污染是一个大问题。',
    category: 'nature',
    difficulty: 'hard',
    grade: '9',
    level: 'middle',
    image: '🏭'
  },
  {
    id: 'protect',
    word: 'protect',
    phonetic: '/prəˈtekt/',
    phoneticUS: '/prəˈtekt/',
    phoneticUK: '/prəˈtekt/',
    meaning: '保护',
    example: 'We need to protect animals.',
    exampleTranslation: '我们需要保护动物。',
    category: 'nature',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '🛡️'
  },
  {
    id: 'recycle',
    word: 'recycle',
    phonetic: '/riːˈsaɪkl/',
    phoneticUS: '/riːˈsaɪkl/',
    phoneticUK: '/riːˈsaɪkl/',
    meaning: '回收利用',
    example: 'We should recycle paper.',
    exampleTranslation: '我们应该回收纸张。',
    category: 'nature',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '♻️'
  },

  // 职业与工作 - Grade 8
  {
    id: 'career',
    word: 'career',
    phonetic: '/kəˈrɪr/',
    phoneticUS: '/kəˈrɪr/',
    phoneticUK: '/kəˈrɪə/',
    meaning: '职业；事业',
    example: 'What is your dream career?',
    exampleTranslation: '你梦想的职业是什么？',
    category: 'jobs',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '💼'
  },
  {
    id: 'engineer',
    word: 'engineer',
    phonetic: '/ˌendʒɪˈnɪr/',
    phoneticUS: '/ˌendʒɪˈnɪr/',
    phoneticUK: '/ˌendʒɪˈnɪə/',
    meaning: '工程师',
    example: 'My father is an engineer.',
    exampleTranslation: '我爸爸是工程师。',
    category: 'jobs',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '👷'
  },
  {
    id: 'scientist',
    word: 'scientist',
    phonetic: '/ˈsaɪəntɪst/',
    phoneticUS: '/ˈsaɪəntɪst/',
    phoneticUK: '/ˈsaɪəntɪst/',
    meaning: '科学家',
    example: 'I want to be a scientist.',
    exampleTranslation: '我想成为一名科学家。',
    category: 'jobs',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    image: '🔬'
  },
  {
    id: 'musician',
    word: 'musician',
    phonetic: '/mjuːˈzɪʃn/',
    phoneticUS: '/mjuːˈzɪʃn/',
    phoneticUK: '/mjuːˈzɪʃn/',
    meaning: '音乐家',
    example: 'She is a famous musician.',
    exampleTranslation: '她是一位著名的音乐家。',
    category: 'jobs',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '🎵'
  },

  // ==================== 九年级词汇 ====================

  // 抽象概念 - Grade 9
  {
    id: 'success',
    word: 'success',
    phonetic: '/səkˈses/',
    phoneticUS: '/səkˈses/',
    phoneticUK: '/səkˈses/',
    meaning: '成功',
    example: 'Hard work leads to success.',
    exampleTranslation: '努力工作通向成功。',
    category: 'abstract',
    difficulty: 'medium',
    grade: '9',
    level: 'middle',
    image: '🏆'
  },
  {
    id: 'challenge',
    word: 'challenge',
    phonetic: '/ˈtʃælɪndʒ/',
    phoneticUS: '/ˈtʃælɪndʒ/',
    phoneticUK: '/ˈtʃælɪndʒ/',
    meaning: '挑战',
    example: 'Life is full of challenges.',
    exampleTranslation: '生活充满了挑战。',
    category: 'abstract',
    difficulty: 'medium',
    grade: '9',
    level: 'middle',
    image: '💪'
  },
  {
    id: 'opportunity',
    word: 'opportunity',
    phonetic: '/ˌɑpərˈtuːnəti/',
    phoneticUS: '/ˌɑpərˈtuːnəti/',
    phoneticUK: '/ˌɒpəˈtjuːnəti/',
    meaning: '机会',
    example: 'This is a good opportunity.',
    exampleTranslation: '这是一个好机会。',
    category: 'abstract',
    difficulty: 'hard',
    grade: '9',
    level: 'middle',
    image: '🎯'
  },
  {
    id: 'responsibility',
    word: 'responsibility',
    phonetic: '/rɪˌspɑnsəˈbɪləti/',
    phoneticUS: '/rɪˌspɑnsəˈbɪləti/',
    phoneticUK: '/rɪˌspɒnsəˈbɪləti/',
    meaning: '责任',
    example: 'Everyone has responsibilities.',
    exampleTranslation: '每个人都有责任。',
    category: 'abstract',
    difficulty: 'hard',
    grade: '9',
    level: 'middle',
    image: '📋'
  },
  {
    id: 'decision',
    word: 'decision',
    phonetic: '/dɪˈsɪʒn/',
    phoneticUS: '/dɪˈsɪʒn/',
    phoneticUK: '/dɪˈsɪʒn/',
    meaning: '决定',
    example: 'Make a wise decision.',
    exampleTranslation: '做一个明智的决定。',
    category: 'abstract',
    difficulty: 'medium',
    grade: '9',
    level: 'middle',
    image: '🤔'
  },
  {
    id: 'achievement',
    word: 'achievement',
    phonetic: '/əˈtʃiːvmənt/',
    phoneticUS: '/əˈtʃiːvmənt/',
    phoneticUK: '/əˈtʃiːvmənt/',
    meaning: '成就',
    example: 'This is a great achievement.',
    exampleTranslation: '这是一个伟大的成就。',
    category: 'abstract',
    difficulty: 'hard',
    grade: '9',
    level: 'middle',
    image: '🏅'
  },

  // 社会与文化 - Grade 9
  {
    id: 'culture',
    word: 'culture',
    phonetic: '/ˈkʌltʃər/',
    phoneticUS: '/ˈkʌltʃər/',
    phoneticUK: '/ˈkʌltʃə/',
    meaning: '文化',
    example: 'Chinese culture is rich.',
    exampleTranslation: '中国文化很丰富。',
    category: 'society',
    difficulty: 'medium',
    grade: '9',
    level: 'middle',
    image: '🎭'
  },
  {
    id: 'tradition',
    word: 'tradition',
    phonetic: '/trəˈdɪʃn/',
    phoneticUS: '/trəˈdɪʃn/',
    phoneticUK: '/trəˈdɪʃn/',
    meaning: '传统',
    example: 'We should keep our traditions.',
    exampleTranslation: '我们应该保持我们的传统。',
    category: 'society',
    difficulty: 'medium',
    grade: '9',
    level: 'middle',
    image: '🎊'
  },
  {
    id: 'society',
    word: 'society',
    phonetic: '/səˈsaɪəti/',
    phoneticUS: '/səˈsaɪəti/',
    phoneticUK: '/səˈsaɪəti/',
    meaning: '社会',
    example: 'We live in a modern society.',
    exampleTranslation: '我们生活在一个现代社会。',
    category: 'society',
    difficulty: 'medium',
    grade: '9',
    level: 'middle',
    image: '👥'
  },
  {
    id: 'community',
    word: 'community',
    phonetic: '/kəˈmjuːnəti/',
    phoneticUS: '/kəˈmjuːnəti/',
    phoneticUK: '/kəˈmjuːnəti/',
    meaning: '社区',
    example: 'Our community is friendly.',
    exampleTranslation: '我们的社区很友好。',
    category: 'society',
    difficulty: 'medium',
    grade: '9',
    level: 'middle',
    image: '🏘️'
  },

  // 旅行与交通 - Grade 8-9
  {
    id: 'journey',
    word: 'journey',
    phonetic: '/ˈdʒɜrni/',
    phoneticUS: '/ˈdʒɜrni/',
    phoneticUK: '/ˈdʒɜːni/',
    meaning: '旅程',
    example: 'Have a safe journey!',
    exampleTranslation: '旅途愉快！',
    category: 'travel',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '🛤️'
  },
  {
    id: 'destination',
    word: 'destination',
    phonetic: '/ˌdestɪˈneɪʃn/',
    phoneticUS: '/ˌdestɪˈneɪʃn/',
    phoneticUK: '/ˌdestɪˈneɪʃn/',
    meaning: '目的地',
    example: 'What is your destination?',
    exampleTranslation: '你的目的地是哪里？',
    category: 'travel',
    difficulty: 'hard',
    grade: '9',
    level: 'middle',
    image: '📍'
  },
  {
    id: 'abroad',
    word: 'abroad',
    phonetic: '/əˈbrɔd/',
    phoneticUS: '/əˈbrɔd/',
    phoneticUK: '/əˈbrɔːd/',
    meaning: '在国外；到国外',
    example: 'I want to study abroad.',
    exampleTranslation: '我想出国留学。',
    category: 'travel',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '✈️'
  },
  {
    id: 'passport',
    word: 'passport',
    phonetic: '/ˈpæspɔrt/',
    phoneticUS: '/ˈpæspɔrt/',
    phoneticUK: '/ˈpɑːspɔːt/',
    meaning: '护照',
    example: 'Do not forget your passport.',
    exampleTranslation: '别忘了带护照。',
    category: 'travel',
    difficulty: 'medium',
    grade: '8',
    level: 'middle',
    image: '🛂'
  },
];

export default middleSchoolVocabulary;
